import styled, { css } from "styled-components"

export const P = styled.p`
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  color: ${({ theme }) => theme.colors.body};
  font-size: 0.85rem;
  margin: 0.5rem 0 0 0;

  ${(props) =>
    props?.simpleForm &&
    css`
      color: #000;
    `}
`
